export default __webpack_public_path__ + "static/media/quote.b92fd1f6.svg";